import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { DashboardsAlphaComponent } from './alpha.page';
export const routes: Routes = [
  { path: 'dashboards', component: DashboardsAlphaComponent },
];
@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
})
export class DashboardsModule { }


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/dashboards/dashboards.module.ts